const currentLocale = new Intl.NumberFormat().resolvedOptions().locale;

export const toLocaleString = (num: any, decimals = 0): string => {
  let value = Number(num);

  if (isNaN(value)) {
    value = 0;
  }

  return value.toLocaleString(currentLocale, {
    minimumFractionDigits: decimals,
    maximumFractionDigits: decimals,
  });
};

// https://en.wikipedia.org/wiki/International_System_of_Units
const SUFFIX_SYMBOL = ['', 'k', 'm', 'bn', 'tn', 'pn', 'en'];

export const toScaledNumber = (num: any, decimals = 1): Nullable<string> => {
  const value = Number(num);

  if (isNaN(value)) {
    return null;
  }

  const tier = (Math.log10(Math.abs(value)) / 3) | 0;

  if (tier === 0) {
    return toLocaleString(value);
  }

  const suffix = SUFFIX_SYMBOL[tier];
  const scale = 10 ** (tier * 3);
  const scaled = value / scale;

  return `${toLocaleString(scaled, decimals).replace(',0', '')}${suffix}`;
};
